/* CHARIS CHI storefront. Native forms remain the non-JavaScript fallback. */
(() => {
  'use strict';
  const q = (s, el = document) => el.querySelector(s);
  const qa = (s, el = document) => Array.from(el.querySelectorAll(s));
  let config = {};
  try { config = JSON.parse(q('#cc-config')?.textContent || '{}'); } catch (_) { /* safe native fallbacks */ }
  document.body.classList.add('cc-enhanced');
  const root = (config.root || '/').replace(/\/?$/, '/');
  const currency = config.currency || 'EUR';
  const money = (amount) => new Intl.NumberFormat(config.locale || 'de-DE', { style: 'currency', currency }).format(Number(amount || 0) / 100);
  const setStatus = (el, message) => { if (el) el.textContent = message; };
  const jsonRequest = async (url, options = {}) => {
    const response = await fetch(url, { credentials: 'same-origin', ...options, headers: { Accept: 'application/json', ...(options.headers || {}) } });
    let data;
    try { data = await response.json(); } catch (_) { throw new Error('Die Antwort konnte nicht gelesen werden. Bitte versuche es erneut.'); }
    if (!response.ok) throw new Error(typeof data.description === 'string' ? data.description : typeof data.message === 'string' ? data.message : 'Das hat leider nicht geklappt. Bitte prüfe deine Auswahl.');
    return data;
  };
  let previousFocus = null;
  const closeDialog = (dialog) => {
    if (!dialog?.open) return;
    dialog.close();
    document.documentElement.style.overflow = '';
    q('[data-cc-menu]')?.setAttribute('aria-expanded', 'false');
    if (previousFocus?.isConnected) previousFocus.focus();
  };
  const openDialog = (dialog) => {
    if (!dialog || typeof dialog.showModal !== 'function') return false;
    qa('dialog.cc-dialog[open]').forEach(closeDialog);
    previousFocus = document.activeElement;
    dialog.showModal();
    document.documentElement.style.overflow = 'hidden';
    q('[data-cc-close]', dialog)?.focus();
    return true;
  };
  let refreshing = null;
  const refreshCart = async () => {
    if (refreshing) return refreshing;
    refreshing = (async () => {
      const [sections, cart] = await Promise.all([
        jsonRequest(`${root}?sections=cc-cart-drawer`),
        jsonRequest(`${root}cart.js`)
      ]);
      const markup = sections['cc-cart-drawer'];
      if (typeof markup !== 'string') throw new Error('Der Warenkorb konnte nicht aktualisiert werden. Bitte öffne die Warenkorbseite.');
      const html = new DOMParser().parseFromString(markup, 'text/html');
      const incoming = q('[data-cc-cart-content]', html);
      const target = q('#cc-cart-dialog [data-cc-cart-content]');
      if (!incoming || !target) throw new Error('Bitte öffne die Warenkorbseite, um deine Auswahl zu sehen.');
      target.replaceChildren(...Array.from(incoming.childNodes));
      qa('[data-cc-count]').forEach(el => { el.textContent = cart.item_count; });
      return cart;
    })();
    try { return await refreshing; } finally { refreshing = null; }
  };
  const afterAdd = async () => {
    if (config.cartMode === 'page') { window.location.assign(config.cart || `${root}cart`); return; }
    try {
      await refreshCart();
      if (!openDialog(q('#cc-cart-dialog'))) window.location.assign(config.cart || `${root}cart`);
    } catch (_) { window.location.assign(config.cart || `${root}cart`); }
  };
  document.addEventListener('click', async event => {
    const target = event.target.closest('button,a,dialog');
    if (!target) return;
    if (target.matches('[data-cc-menu]')) {
      const dialog = q('#cc-mobile-menu');
      if (openDialog(dialog)) target.setAttribute('aria-expanded', 'true');
    }
    if (target.matches('[data-cc-close]')) closeDialog(target.closest('dialog'));
    if (target.matches('dialog.cc-dialog')) {
      const rect = target.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) closeDialog(target);
    }
    if (target.matches('#cc-mobile-menu a')) closeDialog(target.closest('dialog'));
    if (target.matches('[data-cc-open-cart]')) {
      if (config.cartMode === 'page' || !q('#cc-cart-dialog')?.showModal) return;
      event.preventDefault();
      try { await refreshCart(); openDialog(q('#cc-cart-dialog')); }
      catch (_) { window.location.assign(config.cart || `${root}cart`); }
    }
    if (target.matches('[data-cc-flip]')) {
      const card = target.closest('[data-cc-card]');
      const flipped = card.classList.toggle('is-flipped');
      target.setAttribute('aria-expanded', String(flipped));
      const front = q('.cc-card-front', card), back = q('.cc-card-back', card);
      front.inert = flipped; back.inert = !flipped;
      front.setAttribute('aria-hidden', String(flipped)); back.setAttribute('aria-hidden', String(!flipped));
    }
    if (target.matches('[data-cc-cart-remove]')) await changeCart(target.dataset.key, 0);
    if (target.matches('[data-cc-qty]')) {
      const input = q('input[name="quantity"]', target.parentElement);
      if (!input) return;
      const min = Number(input.min) || 1, step = Number(input.step) || 1;
      const max = input.max ? Number(input.max) : Infinity;
      input.value = String(Math.max(min, Math.min(max, (Number(input.value) || min) + Number(target.dataset.ccQty) * step)));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  });
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape') {
      const card = event.target.closest('[data-cc-card].is-flipped');
      if (card) { q('[data-cc-flip]', card)?.click(); q('[data-cc-flip]', card)?.focus(); }
      qa('.cc-nav-dropdown[open]').forEach(menu => { menu.open = false; });
    }
  });
  document.addEventListener('click', event => {
    qa('.cc-nav-dropdown[open]').forEach(menu => { if (!menu.contains(event.target)) menu.open = false; });
  });
  document.addEventListener('cancel', event => { if (event.target.matches('dialog.cc-dialog')) { event.preventDefault(); closeDialog(event.target); } }, true);
  document.addEventListener('change', async event => {
    if (event.target.matches('[data-cc-cart-quantity]')) {
      const value = Number(event.target.value);
      if (!event.target.checkValidity() || !Number.isInteger(value)) { event.target.reportValidity(); return; }
      await changeCart(event.target.dataset.key, value);
    }
  });
  let cartBusy = false;
  async function changeCart(key, quantity) {
    if (cartBusy) return;
    cartBusy = true;
    const panel = q('#cc-cart-dialog [data-cc-cart-content]');
    if (!panel) { cartBusy = false; return; }
    panel.setAttribute('aria-busy', 'true');
    qa('input,button', panel).forEach(el => el.disabled = true);
    try {
      await jsonRequest(`${root}cart/change.js`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: key, quantity }) });
      await refreshCart();
      q('[data-cc-close]', panel)?.focus();
    } catch (error) {
      setStatus(q('[data-cc-cart-status]', panel), error.message);
      qa('input,button', panel).forEach(el => el.disabled = false);
    } finally { panel.removeAttribute('aria-busy'); cartBusy = false; }
  }
  function initTabs(scope) {
    qa('[data-cc-tabs]', scope).forEach(el => {
      if (el.dataset.ccReady) return; el.dataset.ccReady = 'true';
      const tabs = qa('[data-cc-tab]', el);
      const activate = (tab) => {
        tabs.forEach(t => { const active = t === tab; t.setAttribute('aria-selected', String(active)); t.tabIndex = active ? 0 : -1; });
        qa('[data-cc-panel]', el).forEach(p => p.hidden = p.dataset.ccPanel !== tab.dataset.ccTab);
      };
      tabs.forEach((tab, i) => {
        tab.addEventListener('click', () => activate(tab));
        tab.addEventListener('keydown', e => {
          let index = null;
          if (e.key === 'ArrowRight') index = (i + 1) % tabs.length;
          if (e.key === 'ArrowLeft') index = (i - 1 + tabs.length) % tabs.length;
          if (e.key === 'Home') index = 0;
          if (e.key === 'End') index = tabs.length - 1;
          if (index !== null) { e.preventDefault(); activate(tabs[index]); tabs[index].focus(); }
        });
      });
    });
  }
  function initIngredients(scope) {
    qa('[data-cc-ingredients]', scope).forEach(el => {
      if (el.dataset.ccReady) return; el.dataset.ccReady = 'true';
      let category = 'Alle', expanded = el.dataset.compact !== 'true';
      const more = q('[data-cc-ingredient-more]', el);
      const input = q('[data-cc-ingredient-search]', el);
      const update = () => {
        const term = (input?.value || '').trim().toLocaleLowerCase('de'); let visible = 0;
        qa('[data-cc-ingredient]', el).forEach(card => {
          const match = (category === 'Alle' || card.dataset.category === category) && card.dataset.name.toLocaleLowerCase('de').includes(term);
          if (match) visible++;
          card.hidden = !match || (!expanded && !term && category === 'Alle' && visible > 6);
        });
        q('[data-cc-no-ingredients]', el).hidden = visible > 0;
        if (more) more.hidden = expanded || !!term || category !== 'Alle' || visible <= 6;
      };
      more?.addEventListener('click', () => { expanded = true; update(); });
      input?.addEventListener('input', update);
      qa('[data-cc-ingredient-filter]', el).forEach(btn => btn.addEventListener('click', () => {
        category = btn.dataset.ccIngredientFilter;
        qa('[data-cc-ingredient-filter]', el).forEach(b => b.setAttribute('aria-pressed', String(b === btn)));
        update();
      }));
      const fromHash = () => {
        let hash; try { hash = decodeURIComponent(location.hash.slice(1)); } catch (_) { return; }
        if (!hash) return;
        const card = document.getElementById(hash);
        if (card?.matches('[data-cc-ingredient]') && el.contains(card)) {
          category = 'Alle'; expanded = true; if (input) input.value = '';
          qa('[data-cc-ingredient-filter]', el).forEach(b => b.setAttribute('aria-pressed', String(b.dataset.ccIngredientFilter === 'Alle')));
          update(); card.open = true; card.scrollIntoView({ block: 'start', behavior: 'auto' });
        }
      };
      el._ccHashHandler = fromHash; window.addEventListener('hashchange', fromHash); update(); fromHash();
    });
  }
  function initProduct(scope) {
    qa('[data-cc-product]', scope).forEach(el => {
      if (el.dataset.ccReady) return;
      let data; try { data = JSON.parse(q('[data-cc-variants]', el).textContent); } catch (_) { return; }
      el.dataset.ccReady = 'true';
      const form = q('.cc-product-form', el), variantSelect = q('[data-cc-variant]', el), planSelect = q('[data-cc-plan]', el);
      const qty = q('input[name="quantity"]', form);
      let current = null, busy = false;
      const updatePrice = () => {
        if (!current) return;
        const plan = current.plans.find(p => String(p.id) === planSelect.value);
        const price = plan ? plan.price : current.price;
        const compare = plan ? plan.compare : current.compare;
        q('[data-cc-price]', el).textContent = money(price);
        const strike = q('[data-cc-compare]', el);
        strike.hidden = !(compare > price); strike.textContent = money(compare);
        q('[data-cc-sticky-price]', el).textContent = money(price);
        const unit = q('[data-cc-unit-price]', el);
        const unitPrice = plan ? plan.unit_price : current.unit_price;
        unit.hidden = !current.unit || unitPrice == null;
        if (!unit.hidden) unit.textContent = `${money(unitPrice)} / ${current.unit_reference === 1 ? '' : current.unit_reference}${current.unit}`;
        const validPlan = !(current.requires_plan || data.requires_plan) || !!plan;
        qa('[data-cc-add]', el).forEach(btn => {
          btn.disabled = busy || !current.available || !validPlan;
          btn.textContent = busy ? 'Wird hinzugefügt …' : !current.available ? 'Ausverkauft' : !validPlan ? 'Abo derzeit nicht verfügbar' : 'In den Warenkorb';
        });
      };
      const showMedia = (id, animate = true) => {
        const media = qa('[data-media-id]', el).find(m => String(m.dataset.mediaId) === String(id));
        if (!media) return;
        const gallery = q('[data-cc-gallery]', el);
        gallery.scrollTo({ left: media.offsetLeft - gallery.offsetLeft, behavior: animate && !matchMedia('(prefers-reduced-motion: reduce)').matches ? 'smooth' : 'auto' });
        qa('[data-cc-thumb]', el).forEach(btn => btn.setAttribute('aria-current', String(btn.dataset.ccThumb === String(id))));
      };
      const selectVariant = (updateUrl = true) => {
        current = data.variants.find(v => String(v.id) === variantSelect.value);
        if (!current) return;
        qa('[data-cc-variant-choice]', el).forEach(btn => btn.setAttribute('aria-pressed', String(btn.dataset.ccVariantChoice === String(current.id))));
        const oldPlan = updateUrl ? planSelect.value : (new URLSearchParams(location.search).get('selling_plan') || planSelect.value);
        planSelect.replaceChildren();
        if (!(current.requires_plan || data.requires_plan)) planSelect.add(new Option('Einmalige Bestellung', ''));
        current.plans.forEach(plan => planSelect.add(new Option(`${plan.name} · ${money(plan.price)}`, String(plan.id))));
        const hasPlans = current.plans.length > 0;
        q('[data-cc-plan-wrap]', el).hidden = !hasPlans;
        planSelect.disabled = !hasPlans;
        if (current.plans.some(p => String(p.id) === oldPlan)) planSelect.value = oldPlan;
        else if (!(current.requires_plan || data.requires_plan)) planSelect.value = '';
        qty.min = current.min || 1; qty.step = current.increment || 1;
        if (current.max !== null) qty.max = current.max; else qty.removeAttribute('max');
        qty.value = current.min || 1;
        const unit = q('[data-cc-unit-price]', el);
        unit.hidden = !current.unit;
        if (current.unit) unit.textContent = `${money(current.unit_price)} / ${current.unit_reference === 1 ? '' : current.unit_reference}${current.unit}`;
        const formula = current.title.toLowerCase().replace(/\s/g, '').match(/[xχ]([123])/);
        qa('[data-cc-formula]', el).forEach(link => {
          link.hidden = !!(formula && link.dataset.ccFormula && !link.dataset.ccFormula.split(',').includes(`x${formula[1]}`));
        });
        if (current.media) showMedia(current.media, false);
        if (updateUrl) { const url = new URL(location.href); url.searchParams.set('variant', current.id); if (planSelect.value) url.searchParams.set('selling_plan', planSelect.value); else url.searchParams.delete('selling_plan'); history.replaceState({}, '', url); }
        updatePrice();
      };
      variantSelect.addEventListener('change', () => selectVariant());
      qa('[data-cc-variant-choice]', el).forEach(btn => btn.addEventListener('click', () => {
        variantSelect.value = btn.dataset.ccVariantChoice;
        variantSelect.dispatchEvent(new Event('change', { bubbles: true }));
      }));
      planSelect.addEventListener('change', () => {
        updatePrice();
        const url = new URL(location.href);
        if (planSelect.value) url.searchParams.set('selling_plan', planSelect.value); else url.searchParams.delete('selling_plan');
        history.replaceState({}, '', url);
      });
      qa('[data-cc-thumb]', el).forEach(btn => btn.addEventListener('click', () => showMedia(btn.dataset.ccThumb)));
      selectVariant(false);
      const sticky = q('[data-cc-sticky]', el);
      if (sticky && 'IntersectionObserver' in window) {
        const stickyObserver = new IntersectionObserver(entries => {
          const entry = entries[0];
          sticky.classList.toggle('is-quiet', entry.isIntersecting);
        }, { threshold: 0 });
        stickyObserver.observe(form);
        el._ccStickyObserver = stickyObserver;
      }
      form.addEventListener('submit', async event => {
        event.preventDefault();
        if (busy || !current?.available || !form.reportValidity()) return;
        if ((current.requires_plan || data.requires_plan) && !current.plans.some(p => String(p.id) === planSelect.value)) return;
        busy = true; updatePrice(); setStatus(q('[data-cc-product-status]', el), '');
        const body = new FormData(form);
        if (!body.get('selling_plan')) body.delete('selling_plan');
        try {
          await jsonRequest(`${root}cart/add.js`, { method: 'POST', body });
          setStatus(q('[data-cc-product-status]', el), 'Deine Pflege wurde hinzugefügt.');
          await afterAdd();
        } catch (error) { setStatus(q('[data-cc-product-status]', el), error.message); }
        finally { busy = false; updatePrice(); }
      });
    });
  }
  function initBuilder(scope) {
    qa('[data-cc-builder]', scope).forEach(el => {
      if (el.dataset.ccReady) return; el.dataset.ccReady = 'true';
      const items = qa('[data-cc-builder-item]', el), button = q('[data-cc-build-add]', el);
      let selected = [], busy = false;
      const update = () => {
        selected = []; let sum = 0, count = 0, invalidQuantity = false;
        const list = q('[data-cc-build-list]', el); list.replaceChildren();
        items.forEach(item => {
          const check = q('[data-cc-build-check]', item), select = q('[data-cc-build-variant]', item), quantity = q('[data-cc-build-qty]', item);
          const option = Array.from(select.options).find(option => option.value === select.value);
          const blocked = !!q('[data-cc-build-required-plan]', item) || !option || option.dataset.available !== 'true' || option.dataset.requiresPlan === 'true';
          check.disabled = blocked || busy;
          if (blocked) check.checked = false;
          if (!check.checked || !option) return;
          const qtyValue = Number(quantity.value);
          if (!quantity.checkValidity() || !Number.isInteger(qtyValue)) { invalidQuantity = true; return; }
          selected.push({ id: Number(option.value), quantity: qtyValue, properties: { 'Dein Pflege-Set': 'Individuell zusammengestellt' } });
          sum += Number(option.dataset.price) * qtyValue; count += qtyValue;
          const li = document.createElement('li'); li.textContent = `${qtyValue} × ${q('h3', item).textContent.trim()} · ${option.textContent.trim()}`; list.append(li);
        });
        q('[data-cc-build-count]', el).textContent = count;
        q('[data-cc-build-total]', el).textContent = money(sum);
        button.disabled = busy || invalidQuantity || selected.length === 0;
        const status = q('[data-cc-build-status]', el);
        if (invalidQuantity) { status.dataset.quantityError = 'true'; setStatus(status, 'Bitte prüfe die Anzahl deiner ausgewählten Produkte.'); }
        else if (status.dataset.quantityError) { delete status.dataset.quantityError; setStatus(status, ''); }
      };
      items.forEach(item => {
        const select = q('[data-cc-build-variant]', item), quantity = q('[data-cc-build-qty]', item);
        const setRules = () => {
          const option = Array.from(select.options).find(option => option.value === select.value); if (!option) return;
          quantity.min = option.dataset.min || '1'; quantity.step = option.dataset.increment || '1';
          if (option.dataset.max) quantity.max = option.dataset.max; else quantity.removeAttribute('max');
          quantity.value = quantity.min;
        };
        setRules();
        select.addEventListener('change', () => { setRules(); update(); });
      });
      el.addEventListener('change', update); el.addEventListener('input', update);
      button.addEventListener('click', async () => {
        update(); if (busy || !selected.length) return;
        const invalid = items.find(item => q('[data-cc-build-check]', item).checked && !q('[data-cc-build-qty]', item).checkValidity());
        if (invalid) { q('[data-cc-build-qty]', invalid).reportValidity(); return; }
        busy = true; update(); button.textContent = 'Dein Set wird hinzugefügt …';
        setStatus(q('[data-cc-build-status]', el), '');
        try {
          await jsonRequest(`${root}cart/add.js`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: selected }) });
          setStatus(q('[data-cc-build-status]', el), 'Dein Set wurde hinzugefügt.');
          await afterAdd();
        } catch (error) { setStatus(q('[data-cc-build-status]', el), error.message); }
        finally { busy = false; update(); button.textContent = 'Mein Set in den Warenkorb'; }
      });
      update();
    });
  }
  function initReveals(scope) {
    if (!('IntersectionObserver' in window) || matchMedia('(prefers-reduced-motion: reduce)').matches || document.body.classList.contains('cc-no-motion') || window.Shopify?.designMode) return;
    const observer = new IntersectionObserver(entries => entries.forEach(entry => {
      if (entry.isIntersecting) { entry.target.classList.add('cc-reveal-visible'); entry.target.classList.remove('cc-reveal-ready'); observer.unobserve(entry.target); }
    }), { threshold: 0.05, rootMargin: '0px 0px 30px 0px' });
    qa('.cc-heading-row,.cc-heading-center,.cc-story-copy,.cc-benefit', scope).forEach(el => {
      if (el.getBoundingClientRect().top < window.innerHeight) return;
      el.classList.add('cc-reveal-ready'); observer.observe(el);
    });
    scope._ccRevealObserver = observer;
  }
  const init = (scope = document) => { initTabs(scope); initIngredients(scope); initProduct(scope); initBuilder(scope); initReveals(scope); };
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => {
    document.documentElement.style.overflow = '';
    event.target._ccRevealObserver?.disconnect();
    qa('[data-cc-product]', event.target).forEach(el => el._ccStickyObserver?.disconnect());
    qa('[data-cc-ingredients]', event.target).forEach(el => { if (el._ccHashHandler) window.removeEventListener('hashchange', el._ccHashHandler); });
  });
})();
